export default "__VITE_ASSET__DES7QZkY__"